import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 12px;
  .ant-checkbox-wrapper > span + span {
    color: #363636;
    font-weight: 500;
  }
`

export const Container = styled.div`
  margin-top: 16px;
  background-color: #f5f5f5;
  padding: 16px 24px;
  border-radius: 8px;
  .ant-radio-group {
    width: 100%;
    label {
      width: 33.33%;
      text-align: center;
      border: 1px solid #bfbfbf;
      box-shadow: none !important;
      outline: none !important;
      border-right: none;
      padding: 5px 12px;
      height: 40px;
      font-size: 14px;
      color: #757575;
      font-weight: 700;
      border-radius: 8px 0 0 8px;
      svg {
        margin-right: 6px;
      }
      &:hover {
        color: #b9b6b6;
      }
    }
    label + label {
      border-radius: 0 !important;
      border-right: 1.5px solid #bfbfbf;
      border-left: 1.5px solid #bfbfbf;
    }
    label + label + label {
      border-radius: 0 8px 8px 0 !important;
      border-left: none;
    }
    .ant-radio-button-wrapper-checked {
      color: #213f68 !important;
      border-color: #9ecffa;
      background-color: #e7f3fe;
    }
  }
`
